import React from "react";
import { useTranslation } from "react-i18next";

function Services() {
  const { t } = useTranslation('homepage');
  const featuredProperty = {
    id: 1,
    image: "/projects/BelleMare/IMG_7365.JPG",
    address: t('services.items.0.title'),
    details: t('services.items.0.description'),
    isFavorite: false
  };

  const suggestedProperties = [
    {
      id: 2,
      image: "/home1/assets/img/projects/proj2.jpg",
      title: t('services.items.1.title'),
      link: '/innerpages/portfolio',
      isFavorite: false
    },
    {
      id: 3,
      image: "/home1/assets/img/projects/proj3.jpg",
      title: t('services.items.3.title'),
      link: '/innerpages/portfolio',
      isFavorite: true
    },
    {
      id: 4,
      image: "/home1/assets/img/projects/proj4.jpg",
      title: t('services.items.2.title'),
      link: '/innerpages/portfolio',
      isFavorite: false
    }
  ];

  return (
    <section className="tc-property-match-section">
      <div className="content section-padding section-padding-x">
        <div className="container">
          {/* Section Header */}
          <div className="property-header" style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '60px',
            gap: '40px'
          }}>
            {/* Left: Headline */}
            <div style={{ flex: '0 0 50%' }}>
              <h2 style={{
                fontSize: '3rem',
                fontWeight: '700',
                color: '#333',
                margin: 0,
                lineHeight: '1.2',
                fontFamily: 'Montserrat, sans-serif'
              }}>
                {t('services.sectionTitle')}
              </h2>
            </div>
            
            {/* Right: Description */}
            <div style={{ flex: '0 0 40%' }}>
              <p style={{
                fontSize: '1.1rem',
                color: '#666',
                lineHeight: '1.6',
                margin: 0,
                fontFamily: 'Montserrat, sans-serif'
              }}>
                {t('services.sectionSubtitle')}
              </p>
            </div>
          </div>

          {/* Main Content Grid */}
          <div className="services-main-grid" style={{
            display: 'flex',
            gap: '40px',
            alignItems: 'flex-start'
          }}>
            {/* Left: Featured Property Card (60% width) */}
            <div className="services-featured-card" style={{ flex: '0 0 60%' }}>
              <div 
                className="featured-card-wrapper"
                style={{
                  position: 'relative',
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onClick={() => window.location.href = '/innerpages/gallery'}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 15px 50px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.1)';
                }}
              >
                {/* Property Image */}
                <div className="featured-image-container" style={{ position: 'relative', height: '400px' }}>
                  <img
                    src={featuredProperty.image}
                    alt="Featured Property"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                  {/* Darker Overlay */}
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.4)',
                    pointerEvents: 'none'
                  }} />
                </div>

                {/* Property Info Overlay */}
                <div style={{
                  position: 'absolute',
                  bottom: '0',
                  left: '0',
                  right: '0',
                  background: 'linear-gradient(transparent, rgba(0,0,0,0.85))',
                  padding: '40px 30px 30px',
                  borderRadius: '0 0 16px 16px',
                  zIndex: 2
                }}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-end',
                    gap: '20px'
                  }}>
                    <div style={{ flex: 1 }}>
                      <div className="featured-card-title" style={{
                        fontSize: '2.5rem',
                        fontWeight: '700',
                        color: 'rgb(200, 195, 180)',
                        marginBottom: '8px',
                        fontFamily: 'Montserrat, sans-serif'
                      }}>
                        {featuredProperty.address}
                      </div>
                      <div className="featured-card-description" style={{
                        fontSize: '1rem',
                        color: '#e0e0e0',
                        lineHeight: '1.6',
                        fontFamily: 'Montserrat, sans-serif'
                      }}>
                        {featuredProperty.details}
                      </div>
                    </div>
                    
                    {/* View Details Button */}
                    <button style={{
                      width: '50px',
                      height: '50px',
                      borderRadius: '50%',
                      backgroundColor: 'rgb(73, 69, 56)',
                      border: 'none',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontSize: '18px',
                      transition: 'all 0.3s ease',
                      fontFamily: 'Montserrat, sans-serif'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = 'rgb(200, 195, 180)';
                      e.target.style.transform = 'scale(1.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'rgb(73, 69, 56)';
                      e.target.style.transform = 'scale(1)';
                    }}
                    >
                      →
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Right: Property Thumbnails Grid (40% width) */}
            <div className="services-thumbnails-grid" style={{ flex: '0 0 40%' }}>
              <div className="thumbnails-grid-container" style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '20px',
                height: '400px'
              }}>
                {suggestedProperties.map((property, index) => (
                  <div
                    key={property.id}
                    style={{
                      position: 'relative',
                      backgroundColor: '#ffffff',
                      borderRadius: '12px',
                      overflow: 'hidden',
                      boxShadow: '0 8px 25px rgba(0,0,0,0.08)',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                    onClick={() => window.location.href = property.link}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-4px)';
                      e.currentTarget.style.boxShadow = '0 12px 35px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.08)';
                    }}
                  >
                    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                      <img
                        src={property.image}
                        alt={`Service ${property.id}`}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                      />
                      {/* Darker Overlay */}
                      <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        pointerEvents: 'none'
                      }} />
                    </div>
                    
                    {/* Service Title */}
                    <div style={{
                      position: 'absolute',
                      bottom: '0',
                      left: '0',
                      right: '0',
                      background: 'linear-gradient(transparent, rgba(0,0,0,0.95))',
                      padding: '20px 15px 15px',
                      color: 'white',
                      fontSize: '0.9rem',
                      fontWeight: '600',
                      fontFamily: 'Montserrat, sans-serif',
                      zIndex: 2
                    }}>
                      {property.title}
                    </div>
                    
                  </div>
                ))}
                
                {/* More Services Card */}
                <div style={{
                  position: 'relative',
                  backgroundColor: '#ffffff',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 8px 25px rgba(0,0,0,0.08)',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onClick={() => window.location.href = '/innerpages/portfolio'}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 12px 35px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.08)';
                }}
                >
                  <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                    <img
                      src="/home1/assets/img/projects/proj5.jpg"
                      alt="More Services"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                    {/* Darker Overlay */}
                    <div style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: 'rgba(0, 0, 0, 0.5)',
                      pointerEvents: 'none'
                    }} />
                  </div>
                  
                  {/* Service Title */}
                  <div style={{
                    position: 'absolute',
                    bottom: '0',
                    left: '0',
                    right: '0',
                    background: 'linear-gradient(transparent, rgba(0,0,0,0.95))',
                    padding: '20px 15px 15px',
                    color: 'white',
                    fontSize: '0.9rem',
                    fontWeight: '600',
                    fontFamily: 'Montserrat, sans-serif',
                    zIndex: 2
                  }}>
                    {t('services.viewApartmentsButton')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Custom CSS */}
      <style>{`
        .tc-property-match-section {
          background: #ffffff;
        }
        
        /* Tablet and below (991px) */
        @media (max-width: 991px) {
          .property-header {
            flex-direction: column !important;
            gap: 30px !important;
            margin-bottom: 40px !important;
          }
          
          .property-header > div {
            flex: 1 1 100% !important;
            width: 100% !important;
          }
          
          .services-main-grid {
            flex-direction: column !important;
            gap: 30px !important;
          }
          
          .services-featured-card,
          .services-thumbnails-grid {
            flex: 1 1 100% !important;
            width: 100% !important;
          }
          
          .featured-image-container {
            height: 350px !important;
          }
          
          .thumbnails-grid-container {
            grid-template-columns: 1fr 1fr !important;
            height: auto !important;
            gap: 15px !important;
          }
          
          .thumbnails-grid-container > div {
            height: 180px !important;
          }
        }
        
        /* Mobile (767px and below) */
        @media (max-width: 767px) {
          .tc-property-match-section {
            padding: 40px 0 !important;
          }
          
          .tc-property-match-section > div {
            padding-left: 15px !important;
            padding-right: 15px !important;
          }
          
          .property-header {
            margin-bottom: 30px !important;
            gap: 20px !important;
          }
          
          .property-header h2 {
            font-size: 2rem !important;
            line-height: 1.3 !important;
          }
          
          .property-header p {
            font-size: 0.95rem !important;
            line-height: 1.5 !important;
          }
          
          .services-main-grid {
            gap: 20px !important;
          }
          
          .featured-image-container {
            height: 280px !important;
          }
          
          .featured-card-wrapper {
            border-radius: 12px !important;
          }
          
          .featured-image-container > div {
            border-radius: 12px !important;
          }
          
          .thumbnails-grid-container {
            grid-template-columns: 1fr !important;
            gap: 15px !important;
          }
          
          .thumbnails-grid-container > div {
            height: 200px !important;
            border-radius: 10px !important;
          }
          
          /* Adjust overlay text sizes for mobile */
          .featured-card-wrapper > div:last-child {
            padding: 30px 20px 20px !important;
          }
          
          .featured-card-title {
            font-size: 1.8rem !important;
            margin-bottom: 0 !important;
          }
          
          /* Hide description on mobile */
          .featured-card-description {
            display: none !important;
          }
          
          .featured-card-wrapper > div:last-child button {
            width: 45px !important;
            height: 45px !important;
            font-size: 16px !important;
          }
          
          .thumbnails-grid-container > div > div:last-child {
            padding: 15px 12px 12px !important;
            font-size: 0.85rem !important;
          }
        }
        
        /* Small mobile (480px and below) */
        @media (max-width: 480px) {
          .property-header h2 {
            font-size: 1.75rem !important;
          }
          
          .property-header p {
            font-size: 0.9rem !important;
          }
          
          .featured-image-container {
            height: 250px !important;
          }
          
          .featured-card-title {
            font-size: 1.5rem !important;
          }
          
          /* Ensure description stays hidden on small mobile */
          .featured-card-description {
            display: none !important;
          }
          
          .thumbnails-grid-container > div {
            height: 180px !important;
          }
        }
      `}</style>
    </section>
  );
}

export default Services;
